import { Pipe, PipeTransform } from '@angular/core';
import { UnitOfMeasurementEnum } from 'src/app/domain/enums/unit-of-measurement.enum';

@Pipe({
    name: 'unitOfMeasurementFormat',
    standalone: true,
})
export class UnitOfMeasurementFormatPipe implements PipeTransform {
    transform(value: UnitOfMeasurementEnum | string | null | undefined): string {
        if (value == null || value === '') return '';

        switch (value) {
            case UnitOfMeasurementEnum.UNIT:
                return 'unidade';
            case UnitOfMeasurementEnum.HOUR:
                return 'hora';
            case UnitOfMeasurementEnum.METER:
                return 'metro';
            case UnitOfMeasurementEnum.SQUARE_METERS:
                return 'm²';
            case UnitOfMeasurementEnum.CUBIC_METERS:
                return 'm³';
            default:
                return String(value);
        }
    }
}
